
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import DynamicTitle from '@/components/DynamicTitle';
import SEOMetaTags from '@/components/SEOMetaTags';

export default function Haieren() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: "Սխալ",
        description: "Խնդրում եմ մուտքագրի քո էլ. փոստի հասցեն",
        variant: "destructive",
      });
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast({
        title: "Սխալ", 
        description: "Խնդրում եմ մուտքագրի վավերական էլ. փոստի հասցե",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    console.log("Sending email to webhook:", email);

    try {
      const response = await fetch('https://hook.us1.make.com/oz9klpf789iy8q3u4r4vfzawxuo1ngb8', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "no-cors",
        body: JSON.stringify({
          email: email,
          timestamp: new Date().toISOString(),
          source: 'haieren_page',
        }),
      });

      toast({
        title: "Թույն!",
        description: "Քո էլ. փոստը հաջողությամբ ուղարկվեց: Շուտով կստանաս blueprint-ը:",
      });
      
      setEmail('');
    } catch (error) {
      console.error("Error sending email:", error);
      toast({
        title: "Սխալ",
        description: "Չհաջողվեց ուղարկել քո էլ. փոստը: Խնդրում եմ կրկին փորձել:",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOMetaTags 
        title="հAIերեն Blueprint - Armenian AI Newsletter Setup Guide"
        description="Get the complete make.com blueprint for creating your own automated Armenian AI newsletter. Free guide by Aram AI for building AI-powered content automation."
        keywords="AI newsletter, Armenian AI, make.com blueprint, newsletter automation, AI content creation, հAIերेն"
        canonicalUrl="https://tezzarida.io/haieren"
        ogType="website"
      />
      <DynamicTitle title="հAIերեն Blueprint - Armenian AI Newsletter Setup Guide" />
      <Header />
      
      <main className="container mx-auto px-4 py-20">
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
          <div className="max-w-4xl mx-auto space-y-12">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white glow-text leading-tight">
              Ուզում ե՞ս ստանալ հAIերենի make.com blueprint-ը: Գրի մեյլդ ու դիմավորի ֆայլը
            </h1>
            
            <div className="max-w-md mx-auto space-y-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="relative">
                  <Input
                    type="email"
                    placeholder="Մուտքագրի քո էլ. փոստի հասցեն"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full h-12 text-lg bg-white border-2 border-gray-300 rounded-full px-6 text-black placeholder:text-gray-500 focus:border-gray-400 focus:ring-0 focus:outline-none transition-colors duration-300"
                    disabled={isLoading}
                  />
                </div>
                
                <Button
                  type="submit"
                  disabled={isLoading || !email}
                  className="w-full h-12 text-lg font-semibold bg-black hover:bg-black text-white rounded-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(124,58,237,0.5)] hover:shadow-[0_0_25px_rgba(124,58,237,0.8)] disabled:opacity-50 disabled:hover:scale-100 disabled:shadow-[0_0_20px_rgba(124,58,237,0.5)]"
                >
                  {isLoading ? (
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 border-2 border-gray-300 border-t-white rounded-full animate-spin" />
                      Ուղարկվում է...
                    </div>
                  ) : (
                    'Ստանալ Blueprint-ը'
                  )}
                </Button>
              </form>
              
              <p className="text-gray-400 text-sm">
                Ես քեզ կուղարկեմ make.com blueprint-ը, որը կօգնի քեզ ստեղծել քո ավտոմատացված տելեգրամ ալիքը ցանկացած թեմայով:
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
